// src/StaffModal.js - VERSIONE FINALE CON REGOLA DI SALVATAGGIO CORRETTA

import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getPermissionablePages } from './appConfig';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import moment from 'moment';
import StaffDocuments from './StaffDocuments';

const pagesForPermissions = getPermissionablePages();

const tabStyles = {
    container: { 
        display: 'flex', 
        borderBottom: '2px solid #eee', 
        marginBottom: '20px', 
        overflowX: 'auto',      
        whiteSpace: 'nowrap',   
    },
    button: { padding: '10px 15px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '500', color: '#888', borderBottom: '2px solid transparent', whiteSpace: 'nowrap', },
    activeButton: { color: '#0d6efd', borderBottom: '2px solid #0d6efd', },
    content: {
        visibility: 'hidden',
        opacity: 0,
        transition: 'opacity 0.3s ease-out, visibility 0.3s',
        height: 0,      // Aggiunto per nascondere layout
        overflow: 'hidden' // Aggiunto per nascondere layout
    },
    activeContent: {
        visibility: 'visible',
        opacity: 1,
        transition: 'opacity 0.3s ease-in',
        height: 'auto',  // Ripristina altezza
        overflow: 'visible'
    },
};

export function StaffModal({ staffData, onSave, onClose, currentUserProfile }) {
    
    const [contractProfiles, setContractProfiles] = useState([]);
    const [selectedProfileId, setSelectedProfileId] = useState('');
    const [activeTab, setActiveTab] = useState('personal');

    const [generalData, setGeneralData] = useState({ role: '', displayOrder: 0, includeInShifts: true, timeSlots: [], permissions: {} });
    const [personalData, setPersonalData] = useState({ firstName: '', lastName: '', color: '#d3d3d3', codiceFiscale: '', address: '', phone: '' });
    const [contractData, setContractData] = useState({
    startDate: '',
    type: '',
    level: '',
    ccnl: '',
    endDate: '',
    weeklyHours: 0,
    // --- NUOVI CAMPI ---
    hourlyGrossCost: 0,      // Paga Oraria Lorda
    overtimeRate: 0,         // Compenso Straordinario (€/h)
    taxPercentage: 0         // Tasse / Costo Azienda (%) in percentuale
});
    const [bankData, setBankData] = useState({ iban: '' });
    const [leaveBalances, setLeaveBalances] = useState({ vacationTotal: 26, vacationTaken: 0, rolTotal: 40, rolTaken: 0, exFestivitaTotal: 0 });

    const canEditFully = currentUserProfile?.permissions?.staff === 'completo' || currentUserProfile?.permissions?.staff === 'semi-completo';
    const isSelfEditing = currentUserProfile?.uid === staffData?.id;
    const canSelfEditTaken = (currentUserProfile?.permissions?.staff === 'self-edit' && isSelfEditing);

    useEffect(() => {
        const fetchProfiles = async () => {
            // Aggiungi un controllo per assicurarti che il profilo e il centerId ci siano
            if (currentUserProfile && currentUserProfile.centerId) {
                // Usa il percorso corretto e nidificato
                const snapshot = await getDocs(collection(db, 'centers', currentUserProfile.centerId, "contractProfiles")); // ✅ CORRETTO
                const profiles = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setContractProfiles(profiles);
            }
        };
        fetchProfiles();
    }, [currentUserProfile]); // ✅ CORRETTO: Aggiungi dipendenza da currentUserProfile

    useEffect(() => {
        if (staffData) {
            const firstName = staffData.personalData?.firstName || (staffData.name ? staffData.name.split(' ')[0] : '');
            const lastName = staffData.personalData?.lastName || (staffData.name ? staffData.name.split(' ').slice(1).join(' ') : '');

            setGeneralData({
                role: staffData.role || '',
                assignmentType: staffData.assignmentType || 'rotation',
                displayOrder: staffData.displayOrder || 0,
                includeInShifts: staffData.includeInShifts !== false,
                timeSlots: staffData.timeSlots || [],
                permissions: staffData.permissions || {}
            });
            setPersonalData({
                firstName: firstName,
                lastName: lastName,
                color: staffData.color || '#d3d3d3',
                codiceFiscale: staffData.personalData?.codiceFiscale || '',
                address: staffData.personalData?.address || '',
                phone: staffData.personalData?.phone || ''
            });
            
            const initialProfileId = staffData.contractData?.profileId || '';
            setContractData({
    startDate: '',
    endDate: '',
    type: '',
    level: '',
    ccnl: '',
    weeklyHours: 0,
    hourlyGrossCost: 0,
    overtimeRate: 0,
    taxPercentage: 0,
    ...(staffData.contractData || {})
});
setSelectedProfileId(initialProfileId);
setBankData({ iban: '', ...(staffData.bankData || {}) });
setLeaveBalances({
    vacationTotal: 26,
    vacationTaken: 0,
    rolTotal: 40,
    rolTaken: 0,
    exFestivitaTotal: 0,
    ...(staffData.leaveBalances || {})
});
        }
    }, [staffData]);
    
    useEffect(() => {
    if (selectedProfileId) {
        const selectedProfile = contractProfiles.find(p => p.id === selectedProfileId);
        if (selectedProfile) {
            setContractData(prev => ({
                ...prev,
                profileId: selectedProfileId,
                type: selectedProfile.type || prev.type,
                level: selectedProfile.level || prev.level,
                ccnl: selectedProfile.ccnl || prev.ccnl,
                weeklyHours: selectedProfile.weeklyHours || prev.weeklyHours,
                // --- POPOLA NUOVI CAMPI DAL PROFILO ---
                hourlyGrossCost: selectedProfile.hourlyGrossCost || 0,
                overtimeRate: selectedProfile.overtimeRate || 0,
                taxPercentage: selectedProfile.taxPercentage || 0,
                monthlyVacationAccrual: selectedProfile.monthlyVacationAccrual || 0,
                monthlyRolAccrual: selectedProfile.monthlyRolAccrual || 0,
            }));
            // ... (resto dei leaveBalances invariato)
        }
    }
}, [selectedProfileId, contractProfiles]);

    const handleGeneralChange = (field, value) => {
    setGeneralData(prev => {
        const newData = { ...prev, [field]: value };
        
        // AUTOMATISMO: Se imposto BackOffice, disabilito includeInShifts
        if (field === 'assignmentType' && value === 'backoffice') {
            newData.includeInShifts = false;
        }
        
        // Opzionale: Se torno a Rotation, potrei volerlo riabilitare (o lasciare a scelta utente)
        // if (field === 'assignmentType' && value === 'rotation') { newData.includeInShifts = true; }

        return newData;
    });
};
    const handlePersonalChange = (e) => setPersonalData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    const handleContractChange = (e) => setContractData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    const handleBankChange = (e) => setBankData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    const handlePermissionChange = (pageKey, level) => setGeneralData(prev => ({ ...prev, permissions: { ...prev.permissions, [pageKey]: level } }));
    const handleSlotChange = (slotId, field, value) => {
        const newTimeSlots = generalData.timeSlots.map(s => {
            if (s.id === slotId) {
                const updatedSlot = { ...s, [field]: value };
                if (generalData.role === 'Segretaria') {
                    if (field === 'isRecovery') {
                        const baseName = updatedSlot.name.replace(/ REC$/, '').trim();
                        updatedSlot.name = value ? `${baseName} REC` : baseName;
                    } else if (field === 'name') {
                        updatedSlot.isRecovery = typeof value === 'string' && value.endsWith(' REC');
                    }
                }
                return updatedSlot;
            }
            return s;
        });
        handleGeneralChange('timeSlots', newTimeSlots);
    };
    const addTimeSlot = () => {
    const newSlot = { 
        id: uuidv4(), 
        name: 'Nuovo Turno', 
        startTime: '08:00', 
        endTime: '13:00', 
        pauseMinutes: 0, 
        pauseStartTime: '', 
        isRecovery: false, 
        excludeFromAutoCalc: false,
        validFrom: moment().format('YYYY-MM-DD'), // <-- AGGIUNGI
        validUntil: null                         // <-- AGGIUNGI
    };
    handleGeneralChange('timeSlots', [...generalData.timeSlots, newSlot]);
};
    const removeTimeSlot = (slotId) => handleGeneralChange('timeSlots', generalData.timeSlots.filter(s => s.id !== slotId));

    const handleLeaveBalanceChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
            setLeaveBalances(prev => ({ ...prev, [name]: checked }));
            return; // Usciamo qui per la checkbox
        }
    let newValue = Number(value); // Rimuovi '|| 0' per gestire l'input vuoto

    // Se il campo è vuoto o non è un numero, imposta a 0
    if (isNaN(newValue)) {
        newValue = 0;
    }

    // --- ⭐ NUOVA LOGICA DI CONTROLLO COMPLETA ⭐ ---

    // 1. Impedisci a chiunque di inserire valori negativi
    if (newValue < 0) {
        alert("Il valore non può essere negativo.");
        return; // Blocca l'aggiornamento
    }

    // 2. Controllo "solo aumento" per utenti in self-edit
    if (canSelfEditTaken && !canEditFully) {
        if (name.includes('Taken')) {
            const oldValue = leaveBalances[name];
            if (newValue < oldValue) {
                alert("Non hai i permessi per diminuire il valore dei contatori goduti. Contatta un amministratore.");
                return; // Blocca l'aggiornamento
            }
        }
    }
    // --- FINE NUOVA LOGICA ---

    setLeaveBalances(prev => ({ ...prev, [name]: newValue }));
};

    const handleSave = () => {
        const finalFirstName = personalData.firstName.trim();
        const finalLastName = personalData.lastName.trim();

        if (finalFirstName === '') {
            alert('Il Nome è obbligatorio.');
            return;
        }

        const displayName = `${finalFirstName} ${finalLastName}`.trim();

        // --- REGOLA CORRETTA APPLICATA QUI ---
        // Se la persona è inclusa nei turni, il suo 'name' principale è solo il nome di battesimo
        // per compatibilità con l'algoritmo. Altrimenti, usiamo nome e cognome.
        const nameForDatabase = generalData.includeInShifts 
            ? finalFirstName 
            : displayName;

        onSave({
            id: staffData?.id,
            name: nameForDatabase,
            color: personalData.color,
            ...generalData,
            personalData: {
                firstName: finalFirstName,
                lastName: finalLastName,
                codiceFiscale: personalData.codiceFiscale,
                address: personalData.address,
                phone: personalData.phone,
            },
            contractData: { ...contractData, profileId: selectedProfileId },
            bankData,
            leaveBalances, // Questo ora include il flag 'hasLaw104'
        });
    };

    //const showAdvancedTabs = process.env.REACT_APP_SHOW_ADVANCED_TABS === 'true';

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content modal-content-large" onMouseDown={e => e.stopPropagation()}>
                <h3>Modifica Persona</h3>
                <div style={tabStyles.container}>
                    <button onClick={() => setActiveTab('personal')} style={{ ...tabStyles.button, ...(activeTab === 'personal' && tabStyles.activeButton) }}>Dati Personali</button>
                    <button onClick={() => setActiveTab('general')} style={{ ...tabStyles.button, ...(activeTab === 'general' && tabStyles.activeButton) }}>Generale</button>
                    <button onClick={() => setActiveTab('timeSlots')} style={{ ...tabStyles.button, ...(activeTab === 'timeSlots' && tabStyles.activeButton) }}>Fasce Orarie</button>
                            <button onClick={() => setActiveTab('contract')} style={{ ...tabStyles.button, ...(activeTab === 'contract' && tabStyles.activeButton) }}>Contratto</button>
                            <button onClick={() => setActiveTab('balances')} style={{...tabStyles.button, ...(activeTab === 'balances' && tabStyles.activeButton)}}>Contatori Assenze</button>
                            {/* --- NUOVA TAB DOCUMENTI --- */}
                    {/* Mostra solo se l'utente salvato ha un ID (non è una nuova creazione) */}
                    {staffData?.id && (
                         <button onClick={() => setActiveTab('documents')} style={{ ...tabStyles.button, ...(activeTab === 'documents' && tabStyles.activeButton) }}>
                             📁 Archivio Doc.
                         </button>
                    )}
                            <button onClick={() => setActiveTab('bank')} style={{ ...tabStyles.button, ...(activeTab === 'bank' && tabStyles.activeButton) }}>Dati Bancari</button>
                </div>
                
                <div className="modal-scrollable-content">
                    {/* --- TAB: Dati Personali --- */}
                    <div style={activeTab === 'personal' ? tabStyles.activeContent : tabStyles.content}>
                        <div className="form-row">
                            <div className="form-group" style={{ flex: 1 }}><label>Nome</label><input type="text" name="firstName" value={personalData.firstName} onChange={handlePersonalChange} /></div>
                            <div className="form-group" style={{ flex: 1 }}><label>Cognome</label><input type="text" name="lastName" value={personalData.lastName} onChange={handlePersonalChange} /></div>
                        </div>
                        <div className="form-row">
                            <div className="form-group" style={{ flex: 1 }}><label>Colore Associato</label><input type="color" name="color" value={personalData.color} onChange={handlePersonalChange} style={{ width: '100%', height: '40px' }} /></div>
                        </div>
                        <div className="form-group" style={{marginTop: '15px'}}><label>Codice Fiscale</label><input type="text" name="codiceFiscale" value={personalData.codiceFiscale} onChange={handlePersonalChange} /></div>
                        <div className="form-group" style={{marginTop: '15px'}}><label>Indirizzo di Residenza</label><input type="text" name="address" value={personalData.address} onChange={handlePersonalChange} /></div>
                        <div className="form-group" style={{marginTop: '15px'}}><label>Telefono</label><input type="tel" name="phone" value={personalData.phone} onChange={handlePersonalChange} /></div>
                    </div>

                    {/* --- TAB: Generale --- */}
                    <div style={activeTab === 'general' ? tabStyles.activeContent : tabStyles.content}>
                        <fieldset disabled={!canEditFully} style={{border: 'none', padding: 0, margin: 0}}>
                            <div className="staff-modal-grid">
                                <div className="form-row" style={{marginBottom: '15px'}}>
                                    <div className="form-group" style={{flex: 1}}>
                                        <label>Tipo Assegnazione (Calcolo Turni)</label>
                                        <select 
                                            value={generalData.assignmentType} 
                                            onChange={(e) => handleGeneralChange('assignmentType', e.target.value)}
                                            style={{padding: '10px', borderRadius: '5px', border: '1px solid #ccc', width: '100%'}}
                                        >
                                            <option value="rotation">Turnazione (Motore di Calcolo)</option>
                                            <option value="backoffice">BackOffice (Orari Fissi/Ufficio)</option>
                                        </select>
                                    </div>
                                </div>

                                {/* 🎯 FIX: TENDINA RUOLO CRM (Stringhe esatte per le Security Rules) */}
                                <div className="form-row">
                                    <div className="form-group" style={{ flex: 3 }}>
                                        <label style={{fontWeight: 'bold', color: '#0d6efd'}}>Ruolo Gestionale Clienti (CRM)</label>
                                        <select 
                                            value={generalData.role} 
                                            onChange={(e) => handleGeneralChange('role', e.target.value)}
                                            style={{padding: '10px', borderRadius: '5px', border: '2px solid #0d6efd', backgroundColor: '#f0f8ff', width: '100%'}}
                                        >
                                            <option value="Staff">Staff Interno (Nessun accesso al CRM Pazienti)</option>
                                            <option value="Segreteria">Segreteria (Accesso ad Appuntamenti, Cassa e Anagrafiche)</option>
                                            <option value="admin">Amministratore (Accesso Completo al CRM)</option>
                                            <option value="Proprietario">Proprietario (Accesso Illimitato)</option>
                                        </select>
                                        <small style={{display:'block', color:'#666', marginTop:'4px'}}>Definisce le autorizzazioni per il gestionale front-office.</small>
                                    </div>
                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label>Ordine Visual.</label>
                                        <input type="number" value={generalData.displayOrder} onChange={(e) => handleGeneralChange('displayOrder', e.target.value)} />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group-checkbox">
                                        <label style={{opacity: generalData.assignmentType === 'backoffice' ? 0.5 : 1}}>
                                            <input 
                                                type="checkbox" 
                                                checked={generalData.includeInShifts} 
                                                onChange={(e) => handleGeneralChange('includeInShifts', e.target.checked)}
                                                disabled={generalData.assignmentType === 'backoffice'} 
                                            /> 
                                            Includi nel motore di calcolo turni (Algoritmo)
                                        </label>
                                        {generalData.assignmentType === 'backoffice' && (
                                            <small style={{display:'block', color:'#666', marginLeft:'25px'}}>
                                                Disabilitato automaticamente per BackOffice.
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {canEditFully && (
                                <div style={{ textAlign: 'left' }}>
                                    <h4 style={{ margin: '20px 0 15px 0' }}>Permessi per Pagina</h4>
                                    <div className="permissions-grid">
                                        {pagesForPermissions.map(page => (
                                            <div key={page.key} className="permission-item">
                                                <label>{page.label}</label>
                                                <select className="pill-select" value={generalData.permissions[page.key] || 'none'} onChange={(e) => handlePermissionChange(page.key, e.target.value)}>
                                                    <option value="completo">Completo</option><option value="semi-completo">Semi-Completo</option><option value="self-edit">Modifica Propri</option><option value="viewer">Solo Vista</option><option value="none">Nessun Accesso</option>
                                                </select>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </fieldset>
                    </div>

                    {/* --- TAB: Fasce Orarie --- */}
                    <div style={activeTab === 'timeSlots' ? tabStyles.activeContent : tabStyles.content}>
                        <fieldset disabled={!canEditFully} style={{border: 'none', padding: 0, margin: 0}}>
                            <div style={{ textAlign: 'left'}}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><h4 style={{ margin: 0 }}>Gestione Fasce Orarie</h4><button onClick={addTimeSlot} className="add-new-button" style={{ fontSize: '0.8rem', padding: '8px 12px' }}>+ Aggiungi Fascia</button></div>
                                <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '10px 10px 10px 0', marginTop: '10px' }}>
    {generalData.timeSlots.filter(slot => !slot.validUntil || moment(slot.validUntil).isAfter(moment().startOf('day'))).map(slot => (
        <div key={slot.id} className="time-slot-card-modern">
            
            {/* Griglia per Nome, Inizio, Fine */}
            <div className="time-slot-grid">
                <div className="form-group">
                    <label>Nome Turno</label>
                    <input type="text" value={slot.name} onChange={(e) => handleSlotChange(slot.id, 'name', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Inizio</label>
                    <input type="time" value={slot.startTime} onChange={(e) => handleSlotChange(slot.id, 'startTime', e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Fine</label>
                    <input type="time" value={slot.endTime} onChange={(e) => handleSlotChange(slot.id, 'endTime', e.target.value)} />
                </div>
            </div>

            {/* Griglia per Pausa (mostrata solo se Pausa > 0) */}
            <div className="time-slot-pause-grid">
                <div className="form-group">
                    <label>Pausa (min)</label>
                    <input type="number" min="0" step="15" value={slot.pauseMinutes} onChange={(e) => handleSlotChange(slot.id, 'pauseMinutes', parseInt(e.target.value) || 0)} />
                </div>
                {slot.pauseMinutes > 0 && (
                    <div className="form-group">
                        <label>Inizio Pausa</label>
                        <input type="time" value={slot.pauseStartTime} onChange={(e) => handleSlotChange(slot.id, 'pauseStartTime', e.target.value)} />
                    </div>
                )}
            </div>

            {/* Footer per Flag e Pulsante Elimina */}
            <div className="time-slot-footer">
                <div className="time-slot-flags">
                    <label>
                        <input 
                            type="checkbox" 
                            checked={slot.isRecovery || false} 
                            onChange={(e) => handleSlotChange(slot.id, 'isRecovery', e.target.checked)} 
                        />
                        Recupero?
                    </label>
                    <label title="Se attivo, questo turno non verrà usato dal calcolatore automatico dei turni.">
                        <input 
                            type="checkbox" 
                            checked={slot.excludeFromAutoCalc || false} 
                            onChange={(e) => handleSlotChange(slot.id, 'excludeFromAutoCalc', e.target.checked)} 
                        />
                        Escludi da Auto-Calc?
                    </label>
                    <label title="Se attivo, questo turno non sarà visibile nel cambio turno.">
                        <input 
                            type="checkbox" 
                            checked={slot.excludeFromChangeShift || false} 
                            onChange={(e) => handleSlotChange(slot.id, 'excludeFromChangeShift', e.target.checked)} 
                        />
                        Escludi da Cambio Turno?
                    </label>
                </div>
                <button onClick={() => removeTimeSlot(slot.id)} className="delete-button" title="Elimina fascia oraria">X</button>
            </div>

        </div>
    ))}
</div>
                            </div>
                        </fieldset>
                    </div>
                            {/* --- TAB: Contratto --- */}
                            <div style={activeTab === 'contract' ? tabStyles.activeContent : tabStyles.content}>
                                <fieldset disabled={!canEditFully} style={{border: 'none', padding: 0, margin: 0}}>
                                    <div className="form-group" style={{marginBottom: '20px'}}><label>Profilo Contrattuale (opzionale)</label><select value={selectedProfileId} onChange={(e) => setSelectedProfileId(e.target.value)}><option value="">-- Nessun Profilo / Personalizzato --</option>{contractProfiles.map(profile => (<option key={profile.id} value={profile.id}>{profile.name}</option>))}</select></div>
                                    <div className="form-row"><div className="form-group" style={{flex:1}}><label>Data di Assunzione</label><input type="date" name="startDate" value={contractData.startDate} onChange={handleContractChange} /></div><div className="form-group" style={{flex:1}}><label>Data Fine Contratto (opz.)</label><input type="date" name="endDate" value={contractData.endDate} onChange={handleContractChange} /></div></div>
                                    <div className="form-row" style={{marginTop: '15px'}}><div className="form-group" style={{flex:2}}><label>Tipo Contratto</label><input type="text" name="type" value={contractData.type} onChange={handleContractChange} placeholder="Es. Tempo Indeterminato" /></div><div className="form-group" style={{flex:1}}><label>Ore Settimanali</label><input type="number" name="weeklyHours" value={contractData.weeklyHours} onChange={handleContractChange} placeholder="Es. 40" /></div></div>
                                    <div className="form-row" style={{marginTop: '15px'}}><div className="form-group" style={{flex:1}}><label>Livello</label><input type="text" name="level" value={contractData.level} onChange={handleContractChange} placeholder="Es. 4°" /></div><div className="form-group" style={{flex:1}}><label>CCNL</label><input type="text" name="ccnl" value={contractData.ccnl} onChange={handleContractChange} placeholder="Es. Commercio" /></div></div>
                                    {/* --- SEZIONE DATI ECONOMICI (Stima) --- */}
<hr style={{margin: '15px 0', border: '0', borderTop: '1px solid #eee'}} />
<h4 style={{margin: '0 0 10px 0', color: '#333'}}>Dati Economici (Stima Costi)</h4>

<div className="form-row">
    <div className="form-group" style={{flex: 1}}>
        <label>Paga Oraria Lorda (€)</label>
        <input
            type="number"
            step="0.01"
            name="hourlyGrossCost"
            value={contractData.hourlyGrossCost}
            onChange={handleContractChange}
            placeholder="Es. 10.00"
        />
    </div>
    <div className="form-group" style={{flex: 1}}>
        <label>Straordinario (€/h)</label>
        <input
            type="number"
            step="0.01"
            name="overtimeRate"
            value={contractData.overtimeRate}
            onChange={handleContractChange}
            placeholder="Es. 12.00"
        />
    </div>
</div>

<div className="form-row" style={{marginTop: '10px'}}>
    <div className="form-group" style={{flex: 1}}>
        <label>Tasse / Costo Azienda Stimato (%)</label>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
            <input
                type="number"
                step="1"
                name="taxPercentage"
                value={contractData.taxPercentage}
                onChange={handleContractChange}
                placeholder="Es. 30"
                style={{flex: 1}}
            />
            <span style={{fontWeight: 'bold', color: '#555'}}>%</span>
        </div>
        <p style={{fontSize: '0.75rem', color: '#888', marginTop: '5px', fontStyle: 'italic'}}>
            Percentuale da aggiungere al lordo per stimare il costo totale.
        </p>
    </div>
</div>
{/* --- FINE SEZIONE --- */}
                                </fieldset>
                            </div>
                            {/* --- TAB: Contatori Assenze --- */}
<div style={activeTab === 'balances' ? tabStyles.activeContent : tabStyles.content}>
    <fieldset style={{border: 'none', padding: 0, margin: 0}}>
        <h4>Saldo Ferie e Permessi (Aggiornati Mensilmente)</h4>
        <p style={{fontSize: '0.8rem', color: '#888', marginTop: '-10px', marginBottom: '15px'}}>
            Questi sono i saldi attuali disponibili. Verranno incrementati automaticamente il 1° di ogni mese in base al rateo.
            Per un nuovo dipendente (o al primo passaggio a questo gestionale), inserisci qui direttamente
            il residuo che gli spetta a oggi: non serve sapere quanto ha già goduto in passato, solo quanto gli resta.
        </p>
        
        {/* --- NUOVA CHECKBOX PER LEGGE 104 --- */}
        <div className="form-group-checkbox" style={{marginBottom: '20px', padding: '10px', background: '#f0f6ff', borderRadius: '5px'}}>
            <label>
                <input 
                    type="checkbox" 
                    name="hasLaw104" 
                    checked={leaveBalances.hasLaw104 || false} 
                    onChange={handleLeaveBalanceChange}
                    disabled={!canEditFully} 
                />
                Abilita gestione Permessi Legge 104 per questo utente
            </label>
        </div>

        <div className="form-row">
    {/* SALDO ATTUALE FERIE */}
    <div className="form-group" style={{flex:1}}>
        <label style={{color: '#0d6efd'}}>Saldo Ferie ATTUALE (giorni)</label>
        <input 
            type="number" 
            step="0.01"
            name="vacationBalance" 
            // Se non esiste (nuovo utente), parte da 0 o da un valore di default
            value={leaveBalances.vacationBalance !== undefined ? leaveBalances.vacationBalance : 0} 
            onChange={handleLeaveBalanceChange} 
            // Solo chi ha permessi completi può modificare manualmente il saldo
            disabled={!canEditFully} 
            style={{fontWeight: 'bold', border: '2px solid #0d6efd'}}
        />
        <small style={{color: '#666'}}>
            Maturazione automatica mensile: <strong>{contractData.monthlyVacationAccrual || 0}</strong> gg
        </small>
    </div>

    {/* SALDO ATTUALE ROL */}
    <div className="form-group" style={{flex:1}}>
        <label style={{color: '#0d6efd'}}>Saldo ROL ATTUALE (ore)</label>
        <input 
            type="number" 
            step="0.01"
            name="rolBalance" 
            value={leaveBalances.rolBalance !== undefined ? leaveBalances.rolBalance : 0} 
            onChange={handleLeaveBalanceChange} 
            disabled={!canEditFully} 
            style={{fontWeight: 'bold', border: '2px solid #0d6efd'}}
        />
        <small style={{color: '#666'}}>
            Maturazione automatica mensile: <strong>{contractData.monthlyRolAccrual || 0}</strong> h
        </small>
    </div>
</div>
      {/* --- NUOVA SEZIONE: STORICO GODUTO --- */}
       {/* <hr style={{margin: '20px 0', borderTop: '1px dashed #ccc'}} />
        
        <div className="form-row">
            <div className="form-group" style={{flex:1}}>
                <label style={{color: '#666'}}>Ferie Godute (Storico)</label>
                <input 
                    type="number" 
                    step="0.5"
                    name="vacationTaken" 
                    value={leaveBalances.vacationTaken !== undefined ? leaveBalances.vacationTaken : 0} 
                    onChange={handleLeaveBalanceChange} 
                    disabled={!canEditFully} 
                    placeholder="0"
                    style={{backgroundColor: '#f9f9f9'}}
                />
                <small style={{color: '#999'}}>Inserisci qui il totale già goduto per storico.</small>
            </div>

            <div className="form-group" style={{flex:1}}>
                <label style={{color: '#666'}}>ROL Goduti (Storico)</label>
                <input 
                    type="number" 
                    step="0.5"
                    name="rolTaken" 
                    value={leaveBalances.rolTaken !== undefined ? leaveBalances.rolTaken : 0} 
                    onChange={handleLeaveBalanceChange} 
                    disabled={!canEditFully} 
                    placeholder="0"
                    style={{backgroundColor: '#f9f9f9'}}
                />
                <small style={{color: '#999'}}>Inserisci qui il totale già goduto per storico.</small>
            </div>
        </div> */}
        {/* --- FINE NUOVA SEZIONE --- */}  
        {/* Campi nascosti o di sola lettura per storici se vuoi, altrimenti rimuovili */}
    </fieldset>
</div>
{/* --- CONTENUTO NUOVA TAB --- */}
                    <div style={activeTab === 'documents' ? tabStyles.activeContent : tabStyles.content}>
                        {staffData?.id ? (
                            <StaffDocuments targetUserId={staffData.id} />
                        ) : (
                            <p style={{textAlign:'center', padding:'20px'}}>Salva il dipendente prima di caricare documenti.</p>
                        )}
                    </div>
                            {/* --- TAB: Dati Bancari --- */}
                            <div style={activeTab === 'bank' ? tabStyles.activeContent : tabStyles.content}>
                                <div className="form-group"><label>IBAN</label><input type="text" name="iban" value={bankData.iban} onChange={handleBankChange} placeholder="IT..." /></div>
                            </div>
                </div>

                <div>
                    <button onClick={handleSave} className="modal-button confirm-button" style={{ marginTop: '25px' }}>Salva</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}